/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Sex_OtherInputs */

const en_us2_onboarding_sex_other = /** @type {(inputs: Onboarding_Sex_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer not to say`)
};

const pt_br2_onboarding_sex_other = /** @type {(inputs: Onboarding_Sex_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefiro não dizer`)
};

const es_419_onboarding_sex_other = /** @type {(inputs: Onboarding_Sex_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefiero no decirlo`)
};

const pt_pt2_onboarding_sex_other = /** @type {(inputs: Onboarding_Sex_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefiro não dizer`)
};

const fr_fr2_onboarding_sex_other = /** @type {(inputs: Onboarding_Sex_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je préfère ne pas le dire`)
};

const de_de2_onboarding_sex_other = /** @type {(inputs: Onboarding_Sex_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchte ich nicht sagen`)
};

const it_it2_onboarding_sex_other = /** @type {(inputs: Onboarding_Sex_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferisco non dirlo`)
};

/**
* | output |
* | --- |
* | "Prefer not to say" |
*
* @param {Onboarding_Sex_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_sex_other = /** @type {((inputs?: Onboarding_Sex_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Sex_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_sex_other(inputs)
	if (locale === "es-419") return es_419_onboarding_sex_other(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_sex_other(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_sex_other(inputs)
	if (locale === "de-DE") return de_de2_onboarding_sex_other(inputs)
	if (locale === "it-IT") return it_it2_onboarding_sex_other(inputs)
	return en_us2_onboarding_sex_other(inputs)
});
export { onboarding_sex_other as "onboarding.sex.other" }